import React from 'react';
import { Helmet } from 'react-helmet-async';
import SuperheroHero from '../components/SuperheroHero';
import SuperheroNameGenerator from '../components/SuperheroNameGenerator';
import SuperheroFeatures from '../components/SuperheroFeatures';
import SuperheroHowItWorks from '../components/SuperheroHowItWorks';
import SuperheroTestimonials from '../components/SuperheroTestimonials';
import SuperheroGuide from '../components/SuperheroGuide';
import SuperheroSEOContent from '../components/SuperheroSEOContent';
import SuperheroFAQ from '../components/SuperheroFAQ';
import SuperheroCallToAction from '../components/SuperheroCallToAction';

export default function SuperheroPage() {
  return (
    <>
      <Helmet>
        <title>Superhero Team Name Generator | Create Epic Hero Squad Names</title>
      </Helmet>
      <SuperheroHero />
      <SuperheroNameGenerator />
      <SuperheroFeatures />
      <SuperheroHowItWorks />
      <SuperheroTestimonials />
      <SuperheroGuide />
      <SuperheroSEOContent />
      <SuperheroFAQ />
      <SuperheroCallToAction />
    </>
  );
}